import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  getSearchExpenseCategory,
  getSearchSubCategoryByCategoryApi,
  getServiceCenterOptionApi,
  searchVendorApi,
} from "../../services/SearchService";
import {
  createExpenseApi,
  updateExpenseApi,
} from "../../services/ExpenseService";
import { getServiceCenterCashDetailsApi } from "../../services/ServiceApi";
import { formatToIndianNumber } from "../../utilities";
import { useSelector } from "react-redux";
const AddExpenseModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const user = useSelector((state) => state?.auth?.user);
  const [loading, setLoading] = useState(false);
  const [pettyCash, setPettyCash] = useState(0);
  const [selecetdCategory, setSelecetdCategory] = useState(null);
  const [categoryOptionLoading, setCategoryOptionLoading] = useState(false);
  const [categoryOption, setCategoryOption] = useState([]);
  const [subCategoryOption, setSubcategoryOption] = useState([]);
  const [selectedSubcategory, setSelecetdSubCategory] = useState(null);
  const [subcategoryLoading, setSubCategoryLaoding] = useState(false);
  const [vendorOption, setVendorOption] = useState([]);
  const [selectedVendor, setSelecetdVendor] = useState(null);
  const [vendorLoading, setVendorLoading] = useState(false);
  const [serviceCenterOption, setServiCenterOption] = useState([]);
  const [selectedSeviceCenter, setSelectedServiceCenter] = useState(null);
  const [form, setForm] = useState({
    category: "",
    description: "",
    amount: "",
    date: new Date().toISOString().split("T")[0],
    subcategory: "",
    vendor: "",
    lit: "",
    is_checked: false,
  });
  const [error, setError] = useState({});
  const getCategory = (categoryId) => {
    setCategoryOptionLoading(true);
    getSearchExpenseCategory()
      .then((res) => {
        const option = res?.data?.results || [];
        setCategoryOption(option);
        if (categoryId) {
          setSelecetdCategory(
            option?.find((item) => item?.value == categoryId) || null
          );
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setCategoryOptionLoading(false);
      });
  };
  const getVendor = (id) => {
    setVendorLoading(true);
    searchVendorApi()
      .then((res) => {
        const option = res?.data?.results || [];
        setVendorOption(option);
        setSelecetdVendor(option?.find((item) => item?.value == id) || null);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setVendorLoading(false);
      });
  };
  const getSubCategory = (id) => {
    setSubCategoryLaoding(true);
    getSearchSubCategoryByCategoryApi(selecetdCategory?.value || "")
      .then((res) => {
        const option = res?.data?.results || [];
        setSubcategoryOption(option);
        setSelecetdSubCategory(
          option.find((item) => item?.value == id) || null
        );
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setSubCategoryLaoding(false);
      });
  };
  const getSource = () => {
    getServiceCenterCashDetailsApi(user?.service_center_id || "")
      .then((res) => {
        const apiData = res?.data?.results;
        setPettyCash(apiData?.total_petty_cash || 0);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getServiceCenter = () => {
    getServiceCenterOptionApi()
      .then((res) => {
        const option = res?.data?.results || [];
        setServiCenterOption(option);
        // setSelectedServiceCenter(
        //   option?.find((item) => item?.value == id) || null
        // );
        setSelectedServiceCenter(null)
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    if (visible) {
      getCategory(data?.category_id);
      getVendor(data?.vendor || "");
      handleReset();
      if (!user?.is_superuser) {
        getSource();
      }
      if (user?.is_superuser) {
        getServiceCenter();
      }
    }
  }, [visible]);

  useEffect(() => {
    if (selecetdCategory?.value) {
      getSubCategory(data?.subcategory || "");
    }
  }, [selecetdCategory]);

  const handleReset = () => {
    if (data) {
      setForm({
        ...form,
        description: data?.description || "",
        amount: Number(data?.amount || ""),
        date: data?.date || new Date().toISOString().split("T")[0],
        lit: Number(data?.lit || ""),
        is_checked: false,
      });
    } else {
      setForm({
        category: "",
        description: "",
        amount: "",
        date: new Date().toISOString().split("T")[0],
        subcategory: "",
        lit: "",
        vendor: "",
        is_checked: false,
      });
      setSelecetdCategory(null);
      setSelecetdSubCategory(null);
      setSelecetdVendor(null);
    }
    setError({});
  };

  useEffect(() => {
    setForm({
      ...form,
      category: selecetdCategory?.value || "",
      subcategory: selectedSubcategory?.value || "",
      vendor: selectedVendor?.value || "",
    });
    if (error?.category && selecetdCategory?.value) {
      setError({ ...error, category: "" });
    }
    if (error?.subcategory && selectedSubcategory?.value) {
      setError({ ...error, subcategory: "" });
    }
  }, [selecetdCategory, selectedSubcategory, selectedVendor]);
  useEffect(() => {
    if (error?.service_center && selectedSeviceCenter?.value) {
      setError({ ...error, service_center: "" });
    }
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [name]: value }));
    if (value && error?.[name]) {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = () => {
    let error = {};
    if (!form.category) error.category = "Category is required";
    if (selecetdCategory?.label == "Chemical") {
      if (!form?.lit) {
        error.lit = "Unit is required";
      }
    }
    if (!form.description) error.description = "Description is required";
    if (!form.amount) error.amount = "Amount is required";
    if (!form.date) error.date = "Date is required";
    if (!form.subcategory) error.subcategory = "Payment status is required";
    if (user?.is_superuser) {
      if (!selectedSeviceCenter?.value) {
        error.service_center = "Required field";
      }
    }

    setError(error);

    if (Object.keys(error).length === 0) {
      const { lit, is_checked, ...rest } = form;
      let payload;
      if (selecetdCategory?.label === "Chemical") {
        payload = is_checked
          ? {
              payment_amount: form?.amount || "",
              payment_mode: "PETTY_CASH",
              ...rest,
              lit,
            }
          : { ...rest, lit };
      } else {
        payload = is_checked
          ? {
              payment_amount: form?.amount || "",
              payment_mode: "PETTY_CASH",
              ...rest,
            }
          : rest;
      }

      if (data) {
        updateExpense(payload);
      } else {
        addExpense(payload);
      }
    }
  };

  const updateExpense = (payload) => {
    setLoading(true);
    updateExpenseApi(data?.id || "", payload)
      .then(() => {
        toast.success("Expense update successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  const addExpense = (payload) => {
    setLoading(true);
    createExpenseApi(user?.is_superuser?{...payload,service_center:selectedSeviceCenter?.value}:payload)
      .then(() => {
        toast.success("Expense created successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{data ? "Edit Expense" : "Add Expense"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-2 p-1">
          <div className="col-md-6">
            <label className="form-label text-dark">Expense Type</label>
            <Select
              classNamePrefix="select"
              className="react-select"
              placeholder="e.g. Chemical"
              options={categoryOption}
              value={selecetdCategory}
              onChange={setSelecetdCategory}
              isLoading={categoryOptionLoading}
            />
            {error?.category && (
              <small className="text-danger">{error.category}</small>
            )}
          </div>
          <div className="col-md-6">
            <label className="form-label text-dark">Expense Details</label>
            <Select
              classNamePrefix="select"
              className="react-select"
              placeholder="e.g. Polish"
              options={subCategoryOption}
              value={selectedSubcategory}
              onChange={setSelecetdSubCategory}
              isLoading={subcategoryLoading}
            />
            {error?.subcategory && (
              <small className="text-danger">{error?.subcategory}</small>
            )}
          </div>
          {selecetdCategory?.label == "Chemical" && (
            <div className="col-12">
              <label className="form-label text-dark">Unit</label>
              <input
                type="text"
                name="lit"
                className={`form-control ${error?.lit ? "is-invalid" : ""}`}
                value={form.lit}
                placeholder="e.g. 2 Liter"
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    handleInputChange(e);
                  }
                }}
              />
              {error?.lit && <small className="text-danger">{error.lit}</small>}
            </div>
          )}

          <div className="col-md-6">
            <label className="form-label text-dark">Expense Amount</label>
            <input
              type="text"
              name="amount"
              className={`form-control ${error?.amount ? "is-invalid" : ""}`}
              value={form.amount}
              placeholder="e.g. ₹4000"
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  handleInputChange(e);
                }
              }}
            />
            {error?.amount && (
              <small className="text-danger">{error.amount}</small>
            )}
          </div>
          <div className="col-md-6">
            <label className="form-label text-dark">Date</label>
            <input
              type="date"
              name="date"
              className={`form-control ${error?.date ? "is-invalid" : ""}`}
              value={form.date}
              onChange={handleInputChange}
              max={new Date().toISOString().split("T")[0]}
            />
            {error?.date && <small className="text-danger">{error.date}</small>}
          </div>
          {user?.is_superuser && (
            <div className="col-md-6">
              <label className="form-label text-dark">Service Center</label>
              <Select
                classNamePrefix="select"
                className="react-select"
                placeholder="e.g. DCWR"
                options={serviceCenterOption}
                value={selectedSeviceCenter}
                onChange={setSelectedServiceCenter}
                isClearable
              />
              {error?.service_center && (
                <small className="text-danger">{error.service_center}</small>
              )}
            </div>
          )}

          <div className={`${user?.is_superuser ? "col-md-6" : "col-12"}`}>
            <label className="form-label text-dark">Vendor</label>
            <Select
              classNamePrefix="select"
              className="react-select"
              placeholder="Select vendor"
              options={vendorOption}
              value={selectedVendor}
              onChange={setSelecetdVendor}
              isLoading={vendorLoading}
              isClearable
            />
          </div>
          <div className="col-12">
            <label className="form-label text-dark">Description</label>
            <textarea
              name="description"
              className={`form-control ${
                error?.description ? "is-invalid" : ""
              }`}
              value={form.description}
              onChange={handleInputChange}
              rows={2}
              placeholder="Enter description"
            />
            {error?.description && (
              <small className="text-danger">{error.description}</small>
            )}
          </div>
          {!user?.is_superuser && (
            <>
              <div className="col-12 mt-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="paidCheckbox"
                    disabled={pettyCash == 0}
                    checked={form?.is_checked || false}
                    onChange={(e) =>
                      setForm({ ...form, is_checked: e.target.checked })
                    }
                  />
                  <label
                    className={`ms-1 fw-medium align-self-center ${
                      pettyCash === 0 ? "opacity-50" : "cursor-pointer"
                    }`}
                    htmlFor="paidCheckbox"
                  >
                    Mark if expense is already paid
                  </label>
                </div>
              </div>
              <code className="text-light">
                <strong>Note:</strong>
                {` Petty cash balance: ₹${formatToIndianNumber(
                  pettyCash
                )}. If selected, the amount will be deducted. Transaction fails if balance is insufficient.`}
              </code>
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />}
            {data ? "Update" : "Submit"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddExpenseModal;
